import { render, staticRenderFns } from "./edit-patient.vue?vue&type=template&id=b9be1abc&scoped=true"
import script from "./edit-patient.vue?vue&type=script&lang=js"
export * from "./edit-patient.vue?vue&type=script&lang=js"
import style0 from "./edit-patient.vue?vue&type=style&index=0&id=b9be1abc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9be1abc",
  null
  
)

export default component.exports